import { PrimaryButton } from "components/Button/style";
import {
  Button,
  ButtonsContainer,
  Container,
  ContainerHeader,
  FormContainer,
  IconeTooltipServico,
  Title,
} from "./style";
import { Col, Form, Row } from "react-bootstrap";
import { CustomInputModal } from "components/CustomInputModal";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useServicoModelo } from "hooks/useServicoModelo";
import { IFiltroProcessoCriarLoteLicenciamentos } from "../../Interfaces/IFiltroProcessoCriarLoteLicenciamentos";
import { filtroProcessoCriarLoteLicenciamentosSchema } from "../../Validate/validator";
import { useSolicitacaoLicenciamentos } from "hooks/useSolicitacaoLicenciamentos";

interface IProps {
  onSubmit: (
    dados: IFiltroProcessoCriarLoteLicenciamentos,
    idEmpresa: number,
  ) => void;
  habilitarCancelar: boolean;
  onClickCancelar: () => void;
  idEmpresa: number;
}

export function FiltrosProcessosLoteLicenciamento({
  onSubmit,
  habilitarCancelar,
  onClickCancelar,
  idEmpresa,
}: Readonly<IProps>) {
  const { register, handleSubmit, reset, control, setValue } = useForm({
    resolver: yupResolver(filtroProcessoCriarLoteLicenciamentosSchema),
  });

  const onClickLimpar = () => {
    setValue("processos", null);
    setValue("placasChassisRenavams", null);
    setValue("servicoProcesso", null);
  };

  const { validarProcessosVincularLote, validarPlacasChassisVincularLote } =
    useSolicitacaoLicenciamentos();

  const { servicosModeloOptions, listarServicosModelo } = useServicoModelo();

  useEffect(() => {
    listarServicosModelo({ atualizarOptions: true });
  }, []);

  return (
    <Container>
      <ContainerHeader>
        <Title>Adicionar processos</Title>
        {habilitarCancelar && (
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={onClickCancelar}
            outline
            variante="primary"
          >
            Cancelar
          </PrimaryButton>
        )}
      </ContainerHeader>
      <hr />
      <FormContainer>
        <Form
          noValidate
          onSubmit={handleSubmit(
            (dados: IFiltroProcessoCriarLoteLicenciamentos) =>
              onSubmit(dados, idEmpresa),
          )}
        >
          <Row style={{ height: 95 }}>
            <Col>
              <Form.Group>
                <Form.Label>ID Processo</Form.Label>
                <Controller
                  control={control}
                  name="processos"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por ID"
                      onConfirm={onChange}
                      onClickOk={validarProcessosVincularLote}
                      validar={true}
                      style={{ width: "351px" }}
                      placeholderModal="Digite ou copie e cole os IDs dos processos que deseja buscar e tecle ENTER"
                      labelItem="ID Processo"
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Placa, chassi ou renavam</Form.Label>
                <Controller
                  control={control}
                  name="placasChassisRenavams"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por veículo"
                      onConfirm={onChange}
                      onClickOk={validarPlacasChassisVincularLote}
                      validar={true}
                      style={{ width: "351px" }}
                      placeholderModal="Digite ou copie e cole as placas, chassis ou renavams que deseja buscar e tecle ENTER"
                      labelItem="Placa, chassi ou renavam"
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Serviço</Form.Label>
                <Controller
                  control={control}
                  name="servicoProcesso"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={servicosModeloOptions}
                      title=""
                      selectedValue={value}
                      onSelect={onChange}
                      searchable
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <ButtonsContainer>
                  <Button
                    type="reset"
                    outline
                    variante="primary"
                    style={{ marginRight: "8px", width: "76px" }}
                    onClick={onClickLimpar}
                  >
                    Limpar
                  </Button>
                  <Button type="submit" style={{ width: "76px" }}>
                    Buscar
                  </Button>
                </ButtonsContainer>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
